// Fase 5 · Clave de pantalla (`X-Screen`) y `source` del dispositivo a
// partir de la ruta. Puro: sin DOM ni Redux, para poder testearlo.
//
// Claves de pantalla: "tpv.grid", "tpv.carta", "tpv.payment" (overlay del
// PaymentDialog), "tpv.product", "tpv.pedidos", "kds", "admin.<sección>",
// "user.<sección>", "public".

export function screenForPath(pathname) {
  const p = String(pathname || "");
  if (!p.startsWith("/app")) return "public";
  if (/^\/app\/tucarta\/tpv(\/|$)/.test(p)) return "tpv.grid";
  const tpv = p.match(/^\/app\/(?:tpv|franquiciado\/camarero)(\/.*)?$/);
  if (tpv) {
    const rest = tpv[1] || "";
    if (/^\/displays\//.test(rest)) return "kds";
    if (/product/.test(rest)) return "tpv.product";
    if (/^\/pedidos/.test(rest)) return "tpv.pedidos";
    if (/^\/(factura|tickets)/.test(rest)) return "tpv.facturas";
    return "tpv.carta";
  }
  if (/^\/app\/franquiciado\/camarero/.test(p)) return "tpv.carta";
  const parts = p.split("/").filter(Boolean); // ["app", "admin", "licences", ...]
  const area = parts[1] || "home";
  const section = parts[2] || "home";
  if (area === "admin") return `admin.${section}`;
  if (area === "user") return `user.${section}`;
  return `admin.${area === "tucarta" ? section : area}`;
}

// `source` que viaja en el batch del monitor (y que el panel muestra junto
// al nombre del empleado). "tpv-grid" / "tpv-carta" / "kds" / "manage-admin"
// (este último se mantiene por compatibilidad: el monitor y los registros
// históricos ya lo usan para el panel de administración).
export function sourceForPath(pathname) {
  const screen = screenForPath(pathname);
  if (screen === "tpv.grid") return "tpv-grid";
  if (screen.startsWith("tpv.")) return "tpv-carta";
  if (screen === "kds") return "kds";
  if (screen === "public") return null;
  return "manage-admin";
}
